(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/models/startentry.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/models/startentry.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.models.StartEntry = svs.tur.start_subscription.models.Entry.extend({
    CONSTANTS: svs.tur.start_subscription.constants,
    defaults: function() {
      return _.extend(typeof this.constructor.__super__.defaults === 'function' ? this.constructor.__super__.defaults() : this.constructor.__super__.defaults, {
        subscriptionEntry: {},
        subscriptionOptions: {},
        cardEntry: undefined,
        autogiroEntry: undefined,
        communicationType: undefined,
        isPaymentTypeChanged: undefined
      });
    },

    initialize: function() {
      this.listenTo(this, 'change:entry', function(model, entry) {
        this.set(this.parseSelectedEntry(model, entry));
      });
    },

    parseSelectedEntry: function(model, entry) {
      var entryData = {};

      if (entry) {
        if (this.has('paymentType') && this.get('paymentType') !== entry.paymentType) {
          entryData.isPaymentTypeChanged = true;
        }

        entryData.amount = entry.amount;
        entryData.startTime = entry.startTime;
        entryData.stopTime = entry.stopTime;
        entryData.hasActivePayChannel = entry.payChannelActive;
        entryData.hasChangeablePayChannel = model.get('hasChangeablePayChannel');
        entryData.paymentType = entry.paymentType;
        entryData.paymentTypeText = this.CONSTANTS.PAYMENT_TYPE[entry.paymentType].TEXT;
        entryData.isAutogiro = this.CONSTANTS.PAYMENT_TYPE.AUTOGIRO.TYPE === entry.paymentType;
        entryData.isBankcard = this.CONSTANTS.PAYMENT_TYPE.BANK_CARD.TYPE === entry.paymentType;
        entryData.weeklyCost = model.get('subscriptionOptions').weeklyCost;
      }

      return entryData;
    },

    parseEntryOrAnnouncement: function(data) {
      var self = this;
      var entryData = {};
      delete data.requestId;
      delete data.requestInfo;

      entryData.communicationType = data.communicationType;
      entryData.hasChangeablePayChannel = data.paymentTypeChangePossible;

      if (this.CONSTANTS.PAYMENT_TYPE[data.paymentType]) {
        entryData.paymentType = data.paymentType;
      }

      if (data.entryInfo.length < 2) {
        entryData.entry = data.entryInfo[0];
      } else {
        entryData.cardEntry = _.find(data.entryInfo, function(entry) {
          return entry.paymentType === self.CONSTANTS.PAYMENT_TYPE.BANK_CARD.TYPE;
        });
        entryData.autogiroEntry = _.find(data.entryInfo, function(entry) {
          return entry.paymentType === self.CONSTANTS.PAYMENT_TYPE.AUTOGIRO.TYPE;
        });
        entryData.cardEntry.isBankcard = true;
        entryData.autogiroEntry.isAutogiro = true;
      }
      return entryData;
    },

    parseNewSubscription: function(data) {
      delete data.requestId;
      delete data.requestInfo;

      return {
        newSubId: data.subscriptionId
      };
    },

    getEntryOrAnnouncement: function(options) {
      options = options || {};

      var model = this;
      var context = options.context;
      var successCallback = options.success;

      options.success = function(response) {
        var attr = model.parseEntryOrAnnouncement(response);
        model.set(attr);

        svs.components.loader.hide();
        successCallback && successCallback.call(context, model, response, options);
      };

      options.error = model.parseError;

      options.url = svs.core.jupiter.url() + '/subscription/1/subscriptionentry';

      options.attrs = this.get('subscriptionEntry');

      svs.components.loader.show();
      this.sync('create', this, options);
    },

    postNewSubscription: function(options) {
      options = options || {};

      var model = this;
      var context = options.context;
      var successCallback = options.success;

      options.success = function(response) {
        var attr = model.parseNewSubscription(response);
        model.set(attr);

        var storageModel = {
          newSubId: model.get('newSubId'),
          dayCost: svs.utils.format.Currency(parseInt(model.get('subscriptionEntry').wagers[0].wagerAmount, 10)),
          isBankcard: model.get('isBankcard'),
          amount: svs.utils.format.Currency(model.get('entry').amount),
          weeklyCost: svs.utils.format.Currency(model.get('weeklyCost')),
          startTime: svs.utils.date.FormatTime('d/M', model.get('entry').startTime),
          stopTime: svs.utils.date.FormatTime('d/M', model.get('entry').stopTime),
          gameDaysStart: parseInt(model.get('entry').amount, 10) / parseInt(model.get('subscriptionEntry').wagers[0].wagerAmount, 10)
        };
        svs.components.Storage.browser.set('templateObject', 'start_subscription', storageModel, svs.components.Storage.constants.EXPIRES_15M);

        svs.components.loader.hide();
        successCallback && successCallback.call(context, model, response, options);
      };

      options.error = function(error) {
        model.clear({ silent: true });
        model.parseError(error);
      };

      options.url = svs.core.jupiter.url() + '/subscription/2/definesubscription';

      options.attrs = this.get('subscriptionEntry');
      options.attrs.paymentType = this.get('paymentType');
      options.attrs.entryInfo = this.get('entry');

      svs.components.loader.show();
      this.sync('create', this, options);
    }
  });
})(Backbone, _, svs);


 })(window);